export default "__VITE_ASSET__D1b6O_2V__"